import React, { useState, useRef, useEffect} from 'react';
import { FaUser,  FaStore, FaUsersBetweenLines} from "react-icons/fa6";
import {GrView} from "react-icons/gr";
import { AiFillProduct } from "react-icons/ai";
import { TiUserDelete } from "react-icons/ti";
import {Customer, Seller, Provider,  Assoociate } from "../pageInside/Rolle"
import {ELAKAY_URl, ELAKAY_URl1, elakay_API} from "../../config"; 
import Modal from 'react-bootstrap/Modal'
import { isAuthenticated, SetElakayLang, getElakayLang, deleteUserById} from "../auth";
import BusinessCard from '../pageInside/businessCard';
import SharePage from "../pageInside/sharePage";
import Timer from "../pageInside/timer";
import ErrorAlert from "../pageInside/ErrorAlert";




const checkObjEmpty =(obj)=>{
  if(Object.values(obj ? obj: []).length > 0){
      
      return true
  }else {
      // setMessageExp(true)
      return false
  }
  
  }


const thStyle = {
  padding: '14px 20px',
  textAlign: 'left',
  borderBottom: '1px solid #eaeaea'
};

const tdStyle = {
  padding: '14px 20px',
  textAlign: 'left',
  borderBottom: '1px solid #f2f2f2',
  color: '#333'
};

const DateFromTimestamp = (timestamp ) => {
  const date = new Date(Number(timestamp));

  const formatted = date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // met à true si tu veux le format AM/PM
    timeZone: 'America/New_York' // ou laisse par défaut selon ton besoin
  });

  return formatted;
};

  const StyledDateTable = ({ startDate, endDate }) => {
    return (
      <div style={{ marginTop: '30px', fontFamily: 'Arial, sans-serif' }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'
        }}>
          <thead style={{ backgroundColor: '#4A90E2', color: 'white' }}>
            <tr>
              <th style={thStyle}>🕓 Start Date</th>
              <th style={thStyle}>⏰ End Date</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: '#fff' }}>
              <td style={tdStyle}>{startDate}</td>
              <td style={tdStyle}>{endDate}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };


const CardUSer = (props) => {
const { id , obj} = getElakayLang();
const isNullOrEmpty = (value)=> {
  // Check for null, undefined, or false
  if (value == null || value === false || value === undefined) return true;

  // Check if the value is an empty object or array
  if (typeof value === 'object') {
      return Object.keys(value).length === 0;
  }
  // Otherwise, return false (the value is neither null, undefined, false, nor empty)
  return false;
}

 const { token } = isAuthenticated();
    const {
        userInfo,
        fullName,
        email,
        nbrUser = 0,
        getFilterOurTeam,
        setFilterOurTeam,
        User_id,
        loadAllMyUserRef,
        setFullName,
        setRoleName,
        setPageTeam,
        setPageProd,
        setPageShop,
        infoSource
    }= props
     const [error, setError] = useState(null);
      const [success, setSuccess] = useState(null);
    let nbrDayRestant = checkObjEmpty(userInfo) ? Math.abs(new Date(userInfo.ativator[0].experyDate) - new Date()) : 0
    let endDays = checkObjEmpty(userInfo) ? new Date(userInfo.ativator[0].experyDate).getTime() : 0

    const UserRoleLimits = (userActiveRole) => {
      const keysToDisplay = [
        { key: 'maxRoyalite', name: 'Royalty' },
        { key: 'maxSeller', name: 'Maximum Sellers' },
        { key: 'maxProducer', name: 'Maximum Producers' },
        { key: 'maxAssociate', name: 'Maximum Associates' },
        { key: 'maxAdmin', name: 'Maximum Admins' },
        { key: 'maxInvestment', name: 'Maximum Investments' }
      ];
    
      return (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ borderBottom: '2px solid #ccc', textAlign: 'left', padding: '8px' }}>Role Limit</th>
              <th style={{ borderBottom: '2px solid #ccc', textAlign: 'left', padding: '8px' }}>Value</th>
            </tr>
          </thead>
          <tbody>
            {keysToDisplay.map(({ key, name }) => (
              userActiveRole[key] > 0 && <tr key={key}>
                <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{name}</td>
                <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{userActiveRole[key]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    };


    const levelStyle = {
         // position: "absolute",
         float: 'right',
         width: "35px",
         height: "15px",
         fontSize: "8px",
         bottom: "1px", /* Espace depuis le bas */
         right: "10px", /* Espace depuis la droite */
         // fontWeight: "bold",
         backgroundColor: "#d3d3d3"
         // color: "white"
    }

    
    
    const LevelsPage = (Admintean = []) => {
let levels
let getLevel
      if(infoSource.userRole.roleName === 'Associate'){
        levels =[]
        getLevel = (adminTeamLength) => {
          
          if (adminTeamLength === 0 || adminTeamLength === 1 || adminTeamLength === 2 || adminTeamLength === 3) {
            return 1;
          } else if (adminTeamLength === 4) {
            return 2;
          }
        };
      }else if(infoSource.userRole.roleName === 'Investment'){
        levels = [
          { label: "LEVEL 3", color: "#60a5fa" }, // blue-400
          { label: "LEVEL 4", color: "#4ade80" }, // green-400
        ];
        
      getLevel = (adminTeamLength) => {
          
          if (adminTeamLength === 0 || adminTeamLength === 1 || adminTeamLength === 2 || adminTeamLength === 3) {
            return 1;
          } else if (adminTeamLength === 4) {
            return 2;
          }
        };

      }else if (infoSource.userRole.roleName === 'Administrator' ){
        levels = [
          { label: "LEVEL 2", color: "#f87171" }, // red-400
          { label: "LEVEL 3", color: "#60a5fa" }, // blue-400
          { label: "LEVEL 4", color: "#4ade80" }, // green-400
        ];
        
      getLevel = (adminTeamLength) => {
          
          if (adminTeamLength === 0 || adminTeamLength === 1 || adminTeamLength === 2) {
            return 1;
          } else if (adminTeamLength === 3) {
            return 2;
          } else if (adminTeamLength === 4) {
            return 3;
          }
        };

      }else{   
   levels = [
      { label: "LEVEL 1", color: "#483D8B" }, // orange-400
      { label: "LEVEL 2", color: "#f87171" }, // red-400
      { label: "LEVEL 3", color: "#60a5fa" }, // blue-400
      { label: "LEVEL 4", color: "#4ade80" }, // green-400
    ];

  getLevel = (adminTeamLength) => {
      
      if (adminTeamLength === 0 || adminTeamLength === 1) {
        return 1;
      } else if (adminTeamLength === 2) {
        return 2;
      } else if (adminTeamLength === 3) {
        return 3;
      } else if (adminTeamLength >= 4) {
        return 4;
      }
    };
  }


      const level = getLevel(Admintean);
    
      return (
        <div className="relative w-full h-screen bg-gray-100 overflow-hidden"
        style={{
          position: "absolute",
          right: "5px",
          top:"45px"
        }}
        >
        <div className="absolute flex space-x-1 bottom-2 right-2">
          {levels.map((lvl, index) => (
            <div
              key={index}
               className="flex justify-center items-center rounded transition-all duration-500 transform hover:scale-125"
              style={{
                float: 'left',
                width: "12px",
                height: "9px",
                // fontSize: "8px",
                backgroundColor: index < level ? lvl.color : "#d3d3d3",
                opacity: 0,
                animation: `fadeIn 0.6s ease forwards ${index * 0.2}s`,
              }}
            >
              {/* Optionnel: {lvl.label} */}
            </div>
          ))}
        </div>
         {/* Ajouter l'animation keyframes directement ici */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
      </div>
      );
    };

    let userAgree = isNullOrEmpty(userInfo.userActiveRole.userActiveRole)

    const  newRole = (data)=>{
     if(userAgree){
      return {data, oldData: null,}
     }else{
      return {data: data.userActiveRole, oldData : data }
     }
    }
    let activator = userInfo.ativator[0].ativated
    
    let newUserInfo = newRole(userInfo.userActiveRole)  

    let  roleName =  newUserInfo.data.roleName

    let roleLevel = roleName === 'Associate' || roleName === 'Investment' || roleName === 'Administrator'  || roleName === 'Family' ? true : false 
  
    const [showLInkAdd, setShowLInkAdd] = useState(false)

  let urlElakay = ELAKAY_URl !== 'undefined'? ELAKAY_URl :  ELAKAY_URl1

  let shareUrl = !activator && `${urlElakay}/user_Shoosing/${userInfo.ativator[0].token}`

  let chechProductView = !userAgree || !activator || roleLevel ? true : false 


  const titleTranslations = {
          fr: `Nous sommes ravis de vous annoncer qu’un message important concernant Elakay vous a été envoyé par un de nos associés. Pour découvrir notre plan d’affaires, nos conditions, et explorer l’opportunité de devenir vous-même associé, veuillez cliquer sur le lien suivant. Nous sommes impatients de potentiellement vous accueillir au sein de notre équipe.`,
        
          en: `We are pleased to inform you that an important message about Elakay has been sent to you by one of our associates. To discover our business plan, our terms, and explore the opportunity to become an associate yourself, please click on the following link. We look forward to potentially welcoming you to our team.`,
        
          es: `Nos complace informarle que uno de nuestros asociados le ha enviado un mensaje importante sobre Elakay. Para conocer nuestro plan de negocios, nuestras condiciones, y explorar la oportunidad de convertirse en asociado, haga clic en el siguiente enlace. Esperamos poder darle la bienvenida a nuestro equipo.`,
        
          pt: `Temos o prazer de informar que uma mensagem importante sobre o Elakay foi enviada a você por um dos nossos associados. Para conhecer nosso plano de negócios, nossos termos e explorar a oportunidade de se tornar um associado, clique no link a seguir. Estamos ansiosos para possivelmente recebê-lo em nossa equipe.`
        };
  
  
        
      const getTranslationByLang = (translations, lang) => {
          if (translations.hasOwnProperty(lang)) {
            return translations[lang];
          } else {
            return `Translation not available for '${lang}'`;
          }
        };
let boxshowActive = !activator ? '#FF0000' : !userAgree ? '#FFFF00' : '#008000'

let boxshowActive1 = !activator ? 'rgba(255, 0, 0, 0.5)' : !userAgree ? 'rgba(255, 255, 0, 0.5)' : 'rgba(0, 128, 0, 0.5)'

    const styles = {
        container: {
          position: "relative",
          width: "100%",
          maxWidth: "100vw",
          minWidth: "325px",
          // height: "auto",
          // minHeight: "150px",
          height: "150px",
          // padding:"10px",
          // margin: "10px"
        },
        circle: {
          width: "150px",
          height: "150px",
          borderRadius: "50%", // Cercle parfait
          backgroundColor: "#F8F8FF",
          position: "absolute",
          zIndex: 2,
          top: "0",
          left: "0",
          border: "3px solid #A9A9A9", // Bordure verte
          boxShadow: `
            0 0 0 2px ${boxshowActive},
            -3px 0 8px rgba(0, 0, 0, 0.5)
          `,
        },
     rectangle: {
  width: "100%",                   // Corrigé : "with" -> "width"
  minWidth: "250px",
  maxWidth: "350px",
  height: "150px",
  backgroundColor: "#F8F8FF",
  position: "absolute",
  zIndex: 1,
  left: "70px",
  top: "0",
  boxShadow: `0 4px 10px ${boxshowActive1}`,
  display: "flex",
  // justifyContent: "center",
  // alignItems: "center",
  // textAlign: "center",
  padding: "10px",
  color: "#000000",
  fontSize: "14px",
  fontFamily: "Arial, sans-serif",
  boxSizing: "border-box",
  borderRadius: "8px",           // Optionnel : pour un style plus doux
  transition: "all 0.3s ease",   // Optionnel : pour l’animation responsive
},
        text: {
          color: "#000000",
          // marginLeft: "75px",
          fontSize: "14px",
          lineHeight: "1.5",
        },  
        rectangle1: {
          // position: "absolute",
          width: "350px",
          height: "150px",
          margin: "1px",
          backgroundColor: "#FAEBD7",
          zIndex: 4,
          clipPath: `path("M 0 0 Q 75 75 0 150 L 350 150 L 350 0 Z")`,
          /* Custom path to create the arc */
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)'
        },
        float_bottom_right: {
          position: "absolute",
          bottom: "10px", /* Espace depuis le bas */
          right: "10px", /* Espace depuis la droite */
          backgroundColor: "#000000",
          padding: "5px 10px",
          color: "white",
          borderRadius: "5px",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
        }

      };


      const styles2 = {
        container: {
            position: "absolute",
            top: "75px", /* Espace depuis le bas */
          left: "40px", /* Espace depuis la droite */
          display: "flex",
          gap: "10px",
          margin: "20px",
        },
        base: {
          cursor: "pointer",
          padding: "5px 8px",
          borderRadius: "5px",
          fontWeight: "bold",
          transition: "background-color 0.3s, color 0.3s",
        },
        active: {
          backgroundColor: "#F5F5F5", // Light red
          border: "4px solid #000000",
          color: "#d32f2f", // Darker red
        },
        unActive: {
          backgroundColor: "#DCDCDC", // Dark red
          border: "1px solid #708090",
          color: "#000000",
        },
      };


const btnNotOk = (a)=>{
    if(a==='Royalty' || a==='Seller' || a==='Provider'){
        return false 
    }
    return true
}
const btnNotOk2 = (a)=>{
    if(a==='Royalty'){
        return false 
    }
    return true
}
const btnOrtherUser = ()=>{
    setPageTeam(true)
    setPageProd(false)
    setPageShop(false)
    setFullName(fullName)
    setRoleName(roleName)
   setFilterOurTeam({...getFilterOurTeam, userID: User_id})
   getFilterOurTeam.userID = User_id
   loadAllMyUserRef(getFilterOurTeam)

}

const btnShopUser = ()=>{
    setPageTeam(false)
    setPageProd(false)
    setPageShop(true)
    setFullName(fullName)
    setRoleName(roleName)
    setFilterOurTeam({...getFilterOurTeam, userID: User_id})
}
  const ProductView = (
    chechProductView &&  <div style={{ position:'absolute',top: '2px', right: '2px', width: "30px", height: "30px", padding: 0, textAlign: "center", fontSize: "20px", color:"#007399"}}><GrView onClick={()=>setShowLInkAdd(true)}/></div>

    )
      const btnCardUser = ()=>{
        return  <h5 className="m-4"
                style={{...styles2.container,}}
        >
             {btnNotOk(roleName) && <span   style={{
                  ...styles2.base,
                  ...styles2.unActive,
                //   ...(getFilterOurTeam.asc === "asc" ? styles2.active : {}),
                }}
                 onClick={btnOrtherUser}
                 >
                <FaUsersBetweenLines />
                </span>}

                {btnNotOk2(roleName) &&  <>
                 {/* <span
                  style={{
                    ...styles2.base,
                    ...styles2.unActive,
                    // ...(getFilterOurTeam.asc === "desc" ? styles2.active : {}),
                  }}
                //  onClick={()=>setFilterOurTeam({...getFilterOurTeam, asc: 'desc'})}
                 >
                <AiFillProduct />
                </span> */}
                <span
                  style={{
                    ...styles2.base,
                    ...styles2.unActive,
                    // ...(getFilterOurTeam.asc === "desc" ? styles2.active : {}),
                  }}
                  onClick={btnShopUser}
                 >
                <FaStore />
                </span></>}
             

                </h5>
      }

    let experyDate = !userAgree ? userInfo.userActiveRole.userActiveRole.experyDate : endDays? endDays : !isNullOrEmpty(userInfo.userActiveRole.endDate)?  new Date(userInfo.userActiveRole.endDate).getTime() : "new Date().getTime()"
    let StartDate = new Date(userInfo.userActiveRole.startDate).getTime()
    let experyDateTimer = !userAgree ? userInfo.userActiveRole.userActiveRole.experyDate :  endDays 

    const filterlist =  {
  asc: 'asc',
  limit : 10,
  skip : 0,
  roleName: 'null',
  myUser: false,
  grpByrole : false,
  agr: 1,
  sortBy: 'createdAt',
  userID: '',
  search: ''
}

      const infonLinkAdd = ()=>{
        return <Modal
        show={showLInkAdd}
        onHide={() => setShowLInkAdd(false)}
        // dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
    >
        <Modal.Header closeButton>
           
        </Modal.Header>
        <Modal.Body>
        <div className="row justify-content-center">
          <div style={{
          width: "150px",
          height: "150px",
          borderRadius: "50%", // Cercle parfait
          backgroundColor: "#F8F8FF",
          position: "absolute",
          top: "0",
          zIndex: 2,
          border: "3px solid #A9A9A9", // Bordure verte
          boxShadow: `
             0 0 0 2px ${boxshowActive},
            -3px 0 8px rgba(0, 0, 0, 0.5)
          `,
        }

          }> 
             <span style={{ margin:"16px", fontSize: "89px", alignItems: "center", textAlign: "center", justifyContent: "center"}}> 
             <FaUser/>
              </span>
              </div>
          
            <div style={{
              width: "350px",
              height: "150px",
              position: "relative",
              marginTop: "160px",
            }}>
            <h3>{fullName}</h3>
            <h6>{email}</h6>
            
            <p> {infoSource.language(infoSource, "title", "nbrTeam")}: {nbrUser}</p>
          <h5 style={styles.float_bottom_right}>{roleName}</h5>
        </div>
            
     {checkObjEmpty(userInfo) && !activator && <Timer
                            infoSource={infoSource}
                            // setMessageExp ={setMessageExp}
                            nbrdays = {nbrDayRestant} 
                            startDate={endDays}
                            enDate={endDays}
                            />}

          

                  {!userAgree && <Timer
                                    infoSource={infoSource}
                                    nbrdays = {experyDateTimer- new Date()} 
                                    enDate={experyDateTimer}
                                    />  }       
          </div>
          { !userAgree && <div className="row justify-content-center mt-3"> 
         <div style={{
              width: "350px",
              boxShadow: `0 4px 10px rgba(255, 255, 0, 0.8)`,
              // clipPath: `path("M 0 0 Q 75 75 0 150 L 350 150 L 350 0 Z")`,
              // height: "150px",
              position: "relative",
              marginTop: "40px",
            }}>
            <h4>{newUserInfo.oldData.roleName} {!userAgree && " old data"}</h4>
            {UserRoleLimits(newUserInfo.oldData)}
            </div> 
            </div>
            }

 <div className="row justify-content-center mt-3"> 
         <div style={{
              width: "350px",
              boxShadow: `0 4px 10px  rgba(0, 128, 0, 0.5)`,
              // clipPath: `path("M 0 0 Q 75 75 0 150 L 350 150 L 350 0 Z")`,
              // height: "150px",
              position: "relative",
              marginTop: "40px",
              marginBottom: "40px",
            }}>
            <h4>{newUserInfo.data.roleName} {!userAgree && " new data"}</h4>
            {UserRoleLimits(newUserInfo.data)}
            </div> 
            </div>
            
       {!activator && <div className="justify-content-center mt-3">
         <SharePage 
         shareUrl ={shareUrl}
          title ={getTranslationByLang(titleTranslations, obj.code)}
         />
             </div>}
                       
        {!activator && <div style={{ display: "flex", justifyContent: "center", padding: "40px" }}>
<BusinessCard
infoSource={infoSource}
userInfo={userInfo}
logo={elakay_API + "/icon/logo_elakay/logoelakay.ico"} // Remplacez par votre logo
companyName="elakay"
fullName={fullName}
role={roleName}
qrValue={shareUrl} // Lien pour le QR code
barcodeValue="1234567890" // Valeur pour le code-barres
/>
</div>}
<div>
      <h2>📅 Dates d'activité</h2>
      <StyledDateTable 
        startDate={DateFromTimestamp(StartDate)} 
        endDate={DateFromTimestamp(experyDate)} 
      />
       <ErrorAlert 
        error={error}
        success={success}
        setError={setError}
        setSuccess={setSuccess}
        duration={10000} 
        />
    </div>
{!activator && (experyDateTimer- new Date()) <= 0 &&
    <button className="btn btn-dark btn-md py-1 rounded-4" onClick={() => {deleteUserById(User_id, token, setError, setSuccess); loadAllMyUserRef(getFilterOurTeam)}}>
<TiUserDelete />  delete
</button>
      }
       </Modal.Body>
    </Modal>

    }

const cardInside = () =>{
        return <div style={styles.container}>
          <div style={styles.circle}>
             <span style={{ margin:"25px", fontSize: "89px", alignItems: "center", textAlign: "center", justifyContent: "center"}}> 
             <FaUser/>
              </span>
          </div>
          <div style={styles.rectangle}>
            <div style={styles.text}>
            <h3 style={{ marginLeft: "55px",}}>{fullName}</h3>
            <h6 style={{ marginLeft: "73px",}}>{email}</h6>
            
            <p style={{ marginLeft: "74px",}}> {infoSource.language(infoSource, "title", "nbrTeam")}: {nbrUser}</p>
            {btnCardUser()}
            {ProductView}
            
          {!userAgree && <h5 style={{
              position: "absolute",
              bottom: "40px", /* Espace depuis le bas */
              right: "10px", /* Espace depuis la droite */
              backgroundColor: "rgba(255, 255, 0, 0.5)",
              padding: "5px 10px",
              color: "black",
              borderRadius: "5px",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}>{newUserInfo.oldData.roleName}</h5>}
          <h5 style={styles.float_bottom_right}>{roleName}</h5>

        </div>
{LevelsPage(userInfo.userActiveRole.Admintean.length)}
            </div>
          </div>

}

         return (<div> 
{ cardInside()}
          {infonLinkAdd()}
        </div>)
}

export default CardUSer;